<template>
  <div class="flex-1 flex overflow-hidden">
    <div class="flex-1 flex overflow-hidden">
      <main class="flex-1 flex bg-gray-200" v-if="hasLoaded">
        <InboxSidebar />
        <router-view />
      </main>
      <span v-else>
        Loading team inbox....
      </span>
    </div>
  </div>
</template>

<script>
import { getAuth, signInWithCustomToken } from "firebase/auth";

import InboxSidebar from "../../components/TeamInbox/InboxSidebar";

import Inbox from "../../store/Inbox/index";

export default {
  name: "TeamInbox",
  components: {
    InboxSidebar
  },
  data() {
    return {
      hasLoaded: false
    };
  },
  created() {
    this.$store.registerModule("Inbox", Inbox);
    this.$store
      .dispatch("Inbox/getToken")
      .then(response => {
        console.log(response);
        return this.login(response.token);
      })
      .then(() => {
        this.hasLoaded = true;
        this.$store.dispatch("Inbox/getHome");
      });
  },
  beforeDestroy() {
    this.$store.unregisterModule("Inbox");
  },
  methods: {
    login(token) {
      const auth = getAuth();
      return signInWithCustomToken(auth, token);
    },
    joinWaitlist() {
      window.open(
        "https://web.whatsapp.com/send/?phone=+916374746603&text=I need team inbox",
        "_new"
      );
      this.$store
        .dispatch("joinWaitList", {
          requestParams: { feature: "teamInbox" }
        })
        .then(() => {
          this.isSaving = false;
          this.$store.dispatch("getConfig");
        });
    }
  }
};
</script>

<style lang="scss" scoped></style>
